import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

async function fetchAcademyTypes() {
  const response = await apiClient.get("/api/v1/companies/types/");
  return response.data;
}

function useAcademyTypes() {
  return useQuery({
    queryKey: ["academy-types"],
    queryFn: fetchAcademyTypes,
    staleTime: Infinity,
  });
}

export { useAcademyTypes };
